
export function loadScript (scriptUrl: string, options?: any) {
  return createScript(scriptUrl, options);
}

export function loadScriptsInSequence (scriptUrls: Array<string>) {
  return queue(
    scriptUrls.map(url => [createScript, url])
  )
}

function createScript (url: string, options = {}): Promise<any> {
  return new Promise((resolve, reject) => {

    const script = document.createElement('script');
    script.type = "text/javascript";
    script.src = url;

    // tslint:disable-next-line: forin
    for (const attr in options) {
      script[attr] = options[attr];
    }

    script.onload = function () {
      console.log(`${script.src} loaded ...`);
      resolve(true);
    }
    script.onerror = function () {
      reject(true);
    }
    document.head.appendChild(script);
  });
}
function queue (list: Array<any>): Promise<boolean> {
  let p = Promise.resolve(true);
  list.forEach(promise => {
    if (Array.isArray(promise)) {
      p = p.then(() => {
        return promise[0].apply(promise, promise.slice(1))
      })
    } else {
      p = p.then(promise)
    }
  });
  return p
}


